<div class="request-funds card">
    <card i18n-headerTitle headerTitle="Request Funds">
        <div card-body class="request-funds-card-body">
            <div class="request-funds-card-body-container">
                <div class="top-container">
                    <div class="amount-cluster-container">
                        <dashboard-amount-cluster
                            id="available-funds-link-tour"
                            i18n-label="Available Funds link text"
                            label="AVAILABLE FUNDS"
                            [useCurrencyPipe]="true"
                            [value]="(accountSnapshotDataSource.data$ | async)?.availableFunds"
                        >
                        </dashboard-amount-cluster>
                    </div>
                    <div class="button-cluster">
                        <lsq-button
                            *claim="claim.ViewRequestFunds"
                            [size]="md"
                            appearance="primary"
                            (buttonClick)="goToRequestFunds()"
                            class="request-funds-btn"
                            i18n="Request funds button"
                        >
                            Request Funds
                        </lsq-button>
                        <lsq-button
                            appearance="secondary"
                            size="md"
                            i18n
                            (buttonClick)="goToViewAvailableFunds()"
                            >View Available Funds</lsq-button
                        >
                    </div>
                </div>
                <div class="total-available-today-container">
                    <div class="request-funds-total-available-todays-details" i18n>
                        Available funds is the amount of money available in your LSQ account. You
                        can request a transfer of these funds into your company bank account at any
                        time.
                    </div>
                </div>
            </div>
            <div
                class="card-body-container-loading"
                *ngIf="accountSnapshotDataSource.loading$ | async"
            >
                <lsq-circle-loader></lsq-circle-loader>
            </div>
        </div>
    </card>
</div>
